import { useParams, useLocation } from 'react-router-dom'
import { useAuth } from '../../../contexts/AuthContext'
import { useAssessment } from '../../../contexts/AssessmentContext'

const TAB_SEGMENTS = new Set(['intake', 'results', 'm365-report', 'plan', 'policies', 'security', 'vault', 'activity'])

export function usePortalClient() {
  const { clientId: paramClientId } = useParams()
  const location = useLocation()
  const { assignedClient, isAdmin } = useAuth()
  const { clients, loading } = useAssessment()

  // useParams() only works inside the <Route> that defines :clientId.
  // PortalLayout sits outside the inner <Routes>, so we also parse
  // the clientId from the URL path as a fallback for admin preview.
  let urlClientId = paramClientId
  if (!urlClientId && location.pathname.startsWith('/portal/')) {
    const segment = location.pathname.split('/')[2]
    if (segment && !TAB_SEGMENTS.has(segment)) {
      urlClientId = segment
    }
  }

  const clientId = urlClientId || assignedClient?.id
  const client = clients.find(c => c.id === clientId)
  const isAdminPreview = isAdmin && !!urlClientId

  return { client, clientId, loading, isAdminPreview }
}
